import { TStore } from "@/models/store";

const getCheckoutState = (state: TStore) => state.checkoutState || {};

// eslint-disable-next-line no-underscore-dangle
const getPaymentMethod = (state: TStore) =>
    getCheckoutState(state).paymentMethod;

const getTourId = (state: TStore) =>
    getCheckoutState(state)?.tourDetail?.tourId;

const getTourType = (state: TStore) =>
    getCheckoutState(state)?.tourDetail?.tourType;

const getTourOption = (state: TStore) =>
    getCheckoutState(state)?.tourDetail?.option;

const getTotalAmout = (state: TStore) =>
    getCheckoutState(state)?.orderData?.totalAmount;

const getOriginalAmount = (state: TStore) =>
    getCheckoutState(state).orderData.originalAmount;

const getCoupon = (state: TStore) => getCheckoutState(state).orderData.coupon;

const getTravelers = (state: TStore) =>
    getCheckoutState(state).orderData.travelers;
const getSelectedSlot = (state: TStore) =>
    getCheckoutState(state).orderData.selectedSlot;
const getRooms = (state: TStore) => getCheckoutState(state).orderData.rooms;

export {
    getCheckoutState,
    getPaymentMethod,
    getTourId,
    getTourType,
    getTourOption,
    getTotalAmout,
    getOriginalAmount,
    getCoupon,
    getTravelers,
    getSelectedSlot,
    getRooms,
};
